export const CrispChat = {
  openChatBoxMessage: 'Open live chat',
  chat_with_us: 'Chat With Us',
};
